import AddEditPanelContainer from "../../../containers/add-edit-panel";
import AddEditPanel from "./add-edit-panel";
import { pickLists, dropdowns, service } from "../data";

export default AddEditPanelContainer(AddEditPanel, {
    pickLists,
    dropdowns,
    service,
});
